import { gaEvent } from '~/plugins/gtagGA4.js'

export default {
  watch: {
    wrapper: {
      handler (value) {
        this.updateWrapper(value)
        this.updateWrapperAttribution(value)
      },
      deep: true
    }
  },
  methods: {
    wrapperComponents () {
      const wrapper = this.wrapper
      const updateWrapper = this.updateWrapper
      const updateWrapperAttribution = this.updateWrapperAttribution
      const track = this.track
      const video = this.video
      const audioElement = document.querySelector('audio')
      const videoElement = document.querySelector('video')
      const cubeElement = document.querySelector('[cube]')
      const cubeAnimation =
         'property: rotation; to: 0 360 0; loop: true; dur: 20000; easing: linear;'

      if (!AFRAME.components.wrapper) {
        AFRAME.registerComponent('wrapper', {
          init () {
            const canvas = document.querySelector('canvas')

            updateWrapper(wrapper)
            updateWrapperAttribution(wrapper)

            const initMedia = () => {
              if (track && !video) {
                audioElement.setAttribute(
                  'src',
                  track.provider === 'spotify'
                    ? track.preview_url
                    : track.stream_url
                )
                audioElement.play()
                cubeElement.setAttribute('animation', cubeAnimation)
              }

              if (video) {
                videoElement.setAttribute('src', video.file)
                // videoElement.load()
                videoElement.play()
              }

              canvas.removeEventListener('touchend', initMedia)
              canvas.removeEventListener('mouseup', initMedia)
            }

            this.el.addEventListener('mousedown', (e) => {
              canvas.addEventListener('touchend', initMedia)
              canvas.addEventListener('mouseup', initMedia)

              $nuxt.$emit('nextScene')
            })
          },
          remove () {
            this.el.removeObject3D('mesh')
            this.el.removeEventListener('mousedown', this.onMouseDown)
            const canvas = document.querySelector('canvas')

            delete AFRAME.components.wrapper
          }
        })
      }
    },
    updateWrapper (wrapper) {
      const setDefaultModel = this.setDefaultModel
      const wrapperComponent = document.querySelector('[wrapper]')

      // debugger
      const onModelLoaded = function (evt) {
        gaEvent({ event: 'opening_loaded', params: {} })
        // works - testing on polygon
        // const gltf = evt.detail.model // This is the THREE.js GLTF scene
        // console.log('GLTF Scene Loaded:', gltf)

        // // Store the scene object reference instead of trying to store the whole GLTF
        // window.loadedGLTFScene = gltf

        wrapperComponent.removeEventListener('model-loaded', onModelLoaded)
        wrapperComponent.removeEventListener('model-error', onModelError)
      }

      const onModelError = function (evt) {
        setDefaultModel()
        wrapperComponent.removeEventListener('model-loaded', onModelLoaded)
        wrapperComponent.removeEventListener('model-error', onModelError)
      }

      if (wrapperComponent) {
        wrapperComponent.addEventListener('model-loaded', onModelLoaded)
        wrapperComponent.addEventListener('model-error', onModelError)

        if (wrapper && wrapper.formats && wrapper.formats.length) {
          wrapper.formats.forEach(async (format) => {
            if (
              format.formatType === 'GLB' ||
              format.formatType === 'GLTF' ||
              format.formatType === 'GLTF2'
            ) {
              if (
                wrapperComponent &&
                format.root.contentType === 'model/gltf+json'
              ) {
                await wrapperComponent.setAttribute(
                  'gltf-model',
                  format.root.url
                )
              }
            }
          })
        }
        if (wrapper && wrapper.scale) {
          const scale = wrapper.scale
          wrapperComponent.setAttribute('scale', `${scale} ${scale} ${scale}`)
        }
        if (wrapper && wrapper.position) {
          const position = wrapper.position
          wrapperComponent.setAttribute('position', `${position}`)
        }

        if (wrapper && !wrapper.rotate) {
          wrapperComponent.removeAttribute('animation')
        } else {
          wrapperComponent.setAttribute(
            'animation',
            'property: rotation; to: 0 360 0; loop: true; dur: 30000; easing: linear; dir: reverse'
          )
        }
      } else {
        setDefaultModel()
      }
    },
    setDefaultModel () {
      const wrapperComponent = document.querySelector('[wrapper]')
      if (wrapperComponent) { wrapperComponent.setAttribute('gltf-model', 'gltf/audiodrop1.glb') }
    },
    updateWrapperAttribution (wrapper) {
      const attributionElement = document.querySelector('[wrapper-attribution]')
      let description = ''

      if (wrapper && wrapper.authorName) {
        // debugger
        // CONT HERE
        // attributionElement.setAttribute('visible', true)

        if (wrapper.description) {
          description = wrapper.description
            .split('', 30)
            .reduce(
              (o, c) => (o.length === 29 ? `${o}${c}...` : `${o}${c}`),
              ''
            )
        } else {
          description = '3D artwork'
        }

        attributionElement.setAttribute(
          'text',
          'value',
          description + ' by ' + wrapper.authorName
        )
      } else if (attributionElement) {
        attributionElement.setAttribute('text', 'value', '')
      }
    }
  }
}
